module.exports = __webpack_public_path__ + "static/media/cel-app.548f2125.png";